import axios from "axios";
import _axios from "../common/axiosCommon.js";


async function getProjectInfoByID(id) {
    return await _axios({
        method: 'post',
        url: '/scratch/getProjectInfoByID',
        data: {
            projectID: parseInt(id),
        },
    }).then((response) => {
        return response.data
    })
}

async function saveProject(data) {
    return await _axios({
        method: 'post',
        url: '/scratch/saveProject',
        data,
    }).then((response) => {
        return response.data
    })
}

async function getMyProjectList(data) {
    return await _axios({
        method: 'post',
        url: '/scratch/getMyProjectList',
        data,
    }).then((response) => {
        return response.data
    })
}

async function getMayuanProject({ mayuanID }) {
    // https://cdn.imayuan.com/project/fbfa7fd4b8ff4aa4a6ff675ff182ba31.json
    return await axios.get(`https://cdn.imayuan.com/project/${mayuanID}.json`).then((resp) => {
        // console.log(resp.data)
        return resp.data
    })
}

async function deleteProject(projectID) {
    return await _axios({
        method: 'post',
        url: '/scratch/deleteProject',
        data: {
            projectID: parseInt(projectID),
        },
    }).then((response) => {
        return response.data
    })
}

export const ProjectApi = {
    getProjectInfoByID,
    saveProject,
    getMyProjectList,
    getMayuanProject,
    deleteProject
}
